import type { ComponentType } from 'react';
import type { ISimpleFilterModelType, SelectionEventSourceType } from 'ag-grid-community';

// ============================================
// Alignment
// ============================================
export const ALIGN = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right',
} as const;

export type AlignValue = typeof ALIGN[keyof typeof ALIGN];

export const ALIGN_TO_JUSTIFY: Record<AlignValue, 'flex-start' | 'center' | 'flex-end'> = {
  [ALIGN.LEFT]: 'flex-start',
  [ALIGN.CENTER]: 'center',
  [ALIGN.RIGHT]: 'flex-end',
};

// ============================================
// Filters
// ============================================
export const FILTER_TYPES = {
  TEXT: 'agTextColumnFilter',
  NUMBER: 'agNumberColumnFilter',
  DATE: 'agDateColumnFilter',
  SET: 'agSetColumnFilter',
} as const;

export type FilterType = typeof FILTER_TYPES[keyof typeof FILTER_TYPES];

export const DEFAULT_FILTERS: ISimpleFilterModelType[] = [
  'contains',
  'notContains',
  'equals',
  'notEqual',
];

// ============================================
// Cell Editors
// ============================================
export const CELL_EDITOR_TYPES = {
  LARGE_TEXT: 'agLargeTextCellEditor',
  NUMBER: 'agNumberCellEditor',
  SELECT: 'agSelectCellEditor',
  CHECKBOX: 'agCheckboxCellEditor',
} as const;

export type CellEditorType = typeof CELL_EDITOR_TYPES[keyof typeof CELL_EDITOR_TYPES] | ComponentType<any>;

// ============================================
// Cell Renderers
// ============================================
export const CELL_RENDERER_TYPES = {
  CHECKBOX: 'agCheckboxCellRenderer',
} as const;

// ============================================
// Row Selection
// ============================================
export const TABLE_ROW_SELECTION = {
  SINGLE: 'singleRow',
  MULTIPLE: 'multiRow',
} as const;

export type TableRowSelectionMode = typeof TABLE_ROW_SELECTION[keyof typeof TABLE_ROW_SELECTION];

export const MULTIPLE_SELECTION_OPTIONS = {
  ALL: 'all',
  FILTERED: 'filtered',
} as const;

// ============================================
// Misc
// ============================================

export const ACTIONS_TRIGGERED_BY_USER = new Set<SelectionEventSourceType>([
  'checkboxSelected',
  'uiSelectAllFiltered',
  'apiSelectAll',
]);

// ============================================
// Pagination
// ============================================
export const PAGE_SIZES = [10, 20, 50, 100];
